<!-- The Design Lab's companion pane: the create trigger and its hint, nothing else. A failed drop
     says so in a toast, with Retry when the workbook was made and only its stitch failed. -->
<div
  appDroppable
  [appDroppableDisabled]="busy()"
  [appDroppablePredicate]="accepts"
  (appDroppableEnter)="dragOver.set(true)"
  (appDroppableLeave)="dragOver.set(false)"
  (appDroppableDrop)="drop($event)"
>
  <app-quick-action-button
    [label]="S['New workbook']"
    [hint]="busy() ? S['Creating…'] : S['Drag to create']"
    [dropLabel]="S['Drop to create']"
    [dragOver]="dragOver()"
    [ariaLabel]="S['New workbook']"
    stchPopover
    stchPopoverTrigger="click"
    stchPopoverPlacement="bottomLeft"
    [stchPopoverContent]="menu"
  />
</div>

<!-- Slides' four, less "Create with Stitchy" (Oleg, 2026-10-10: "You can drop Create with Stitchy
     for now"). Blank creates outright — no form — which is what Slides' panel and the Design Lab
     both do. -->
<ng-template #menu>
  <app-context-menu-window>
    <app-context-menu-item [title]="S['Blank workbook']" [disabled]="busy()" [close]="true" (execute)="blank()" />
    <app-context-menu-item [title]="S['From a template']" [disabled]="busy()" [close]="true" (execute)="chooseTemplate()" />
    <app-context-menu-item [title]="S['Import spreadsheet…']" [disabled]="busy()" [close]="true" (execute)="chooseImport()" />
  </app-context-menu-window>
</ng-template>
